<template>
    <div class="dropdown-menu">
        <div v-for="c in categories" :key="c.index">
            <router-link class="text-white dropdown-item display-4" :to="{name: 'searchByKeyword', params: {type: 'category', keyword: c.slug, page: 1}  }">{{c.name}} （{{c.ac}}）</router-link>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'CategoryListIndex',
        data: function () {
            return {
                categories: [],
            };
        },
        methods: {
            getArticleCategoryList() {
                var url="http://api.go4pro.org/go4pro/article/countByCategory";
                fetch(url)
                    .then(res => {
                        return res.json();
                    })
                    .then(json => {
                        this.categories=json;
                    });

            }
        },
        created: function() {
            this.getArticleCategoryList();
        }
    }
</script>